// extracted by mini-css-extract-plugin
module.exports = {"root":"r3gqF","section":"_2wRGy","carouselContainer":"_2QJ8B","errorBox":"_2XwFA","errorTitle":"_1wFOB","errorLink":"_2G3uQ"};